export default {
    font: "'Ubisoft Sans Regular',arial,sans-serif",
    boldFont: "'Ubisoft Sans Bold',arial,sans-serif",
    fontWeight: 'unset'
};
